export default {"src":"/_next/static/media/notecard-guides.ade9f4e7.svg","height":32,"width":27,"blurWidth":0,"blurHeight":0};